/* Copyright (c) 2018 Backpack Health LLC */
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import IconHealthInfo from '../../../../components/icons/IconHealthInfo';
import FlexRow from '../../../../components/FlexRow';
import { useProfile } from '../../../../hooks/useProfile';
import ProfileModel from '../../../../../models/ProfileModel';
import { useUIState } from '../../../../hooks/useUIState';

interface Props {
  value?: any;
  profileId: number;
  source: {
    provider: string;
    value?: any;
    values?: any[];
    unit_id?: number;
  };
}

const BackpackSource = (props: Props) => {
  const { source, profileId, value } = props;

  const [profileData] = useProfile(profileId);
  const [uiState] = useUIState();

  if (!source) { return null; }

  const profile = new ProfileModel(profileData.data);
  const profileName = profile.greetingName();
  const isMain = uiState.isActiveProfileMainProfile;

  return (
    <FlexRow style={{ justifyContent: 'flex-start', marginTop: 18 }}>
      <IconHealthInfo.Small color="gsMedDark" />

      <div className="font-caption font-color-gsMedDark" style={{ marginLeft: 10 }}>
        {
          isMain
          ? <FormattedMessage id="surveyQuestion.backpackPrefill.user.label" />
          : <FormattedMessage id="surveyQuestion.backpackPrefill.notUser.label" values={{ string1: profileName }} />
        }
        {value && <>: {value}</>}
      </div>
    </FlexRow>
  );
};

export default BackpackSource;
